<template>
  <div class="overflow-x-auto">
    <table class="w-full border-collapse border border-gray-300 text-sm">
      <thead>
        <tr class="bg-gray-100 text-left">
          <th class="border border-gray-300 p-2">STT</th>
          <th class="border border-gray-300 p-2">Ngày <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Diễn giải<span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">ĐVT <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Số lượng <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Đơn giá <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Số tiền <span class="text-red-500">*</span></th>
          <th class="border border-gray-300 p-2">Ghi chú</th>
        </tr>
      </thead>

      <tbody>
        <!-- TOTAL -->
        <tr>
          <td class="border border-gray-300 p-2 text-center" colspan="6">TOTAL</td>
          <td class="border border-gray-300 p-2 text-center">
            <input class="w-full border rounded p-1 text-sm text-right" :value="formatNumber(Math.floor(totalAllMoney))" disabled />
          </td>
          <td class="border border-gray-300 p-2 text-center">
            <textarea v-model="localValue.totalNote"
              class="w-full border rounded p-1 text-sm focus:border-blue-500 focus:outline-none" />
          </td>
        </tr>

        <!-- Các section -->
        <template v-for="section in sections">
          <tr>
            <td colspan="6" class="border border-gray-300 p-2 text-center font-bold bg-gray-50">
              {{ section.label }}
            </td>
            <td class="border border-gray-300 p-2 text-right font-bold bg-gray-50">
              {{ formatNumber(Math.floor(getTotalMoney(localValue[section.key]))) }}
            </td>
            <td class="border border-gray-300 p-2 bg-gray-50"></td>
          </tr>


          <tr v-for="(item, index) in localValue[section.key]" :key="`${section.key}-${index}`">
            <td class="border border-gray-300 p-2 text-center">{{ index + 1 }}</td>

            <td class="border border-gray-300 p-2 text-center">
              <input v-model="item.date" type="date" class="w-full border rounded p-1 text-sm" />
            </td>

            <td class="border border-gray-300 p-2 text-center relative">
              <div class="search-box">
                <input type="text" v-model="item.detail" @input="searchProduct(item)" placeholder="Nhập tên sản phẩm..."
                  class="input min-w-[180px] w-full border rounded p-1 text-sm" />

                <!-- Danh sách gợi ý -->
                <ul v-if="item.showSuggestions && item.results?.length"
                  class="absolute bg-white border border-gray-300 w-full max-h-40 overflow-auto z-50 text-left">
                  <li v-for="product in item.results" :key="product.id" @click="selectProduct(item, product)"
                    class="p-2 hover:bg-gray-100 cursor-pointer">
                    {{ product.name }} ({{ product.code }})
                  </li>
                </ul>
              </div>
            </td>

            <td class="border border-gray-300 p-2 text-center">
              <input v-model="item.unit" type="text" class="min-w-[60px] w-full border rounded p-1 text-sm" />
            </td>

            <td class="border border-gray-300 p-2 text-center">
              <input v-model="item.quantity" min="0" @input="updateQuantityItem($event, item)" @keypress="onlyNumberAndDot($event)"
                class="min-w-[80px] w-full border rounded p-1 text-sm text-right" />
            </td>

            <td class="border border-gray-300 p-2 text-center">
              <input data-key="price" :value="formatNumber(item.price)" min="0" @input="updateMoneyItem($event, item)"
                @keypress="onlyNumber" class="min-w-[120px] w-full border rounded p-1 text-sm text-right" />
            </td>

            <td class="border border-gray-300 p-2 text-center">
              <input class="min-w-[120px] w-full border rounded p-1 text-sm text-right"
                :value="formatNumber(Math.floor(item.money))" disabled />
            </td>
            <td class="border border-gray-300 p-2 text-center">
              <div class="flex flex-row">
                <textarea v-model="item.note" class="min-w-[180px] w-full border rounded p-1 text-sm" />
                <button v-if="localValue[section.key].length > 1" @click="removeRow(section.key, index)"
                  class="text-red-500 ml-[10px]">
                  <font-awesome-icon :icon="['fas', 'trash-can']" />
                </button>
              </div>
            </td>

          </tr>

          <tr>
            <td colspan="9" class="border border-gray-300 p-2 text-center font-bold text-blue-500 cursor-pointer"
              @click="addRow(section.key)">
              <font-awesome-icon :icon="['fas', 'plus']" /> Thêm {{ section.shortLabel }}
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import { onlyNumber, formatNumber, unformatNumber } from '@/utils/onlyNum';

const API_URL = process.env.VUE_APP_API_URL;

export default {
  props: {
    value: { type: Object, required: true },
    productsItem: { type: Array, default: [] }
  },
  data() {
    return {
      sections: [
        { key: "totalInventoryMaterials", label: "TỔNG NVL TỒN KHO", shortLabel: "NVL" },
        { key: "totalCeremonyMaterials", label: "TỔNG VT LẺ", shortLabel: "VL LẺ" },
        { key: "totalNonInventoryMaterials", label: "TỔNG NVL KHÔNG TỒN KHO", shortLabel: "NVL KHÔNG TỒN KHO" },
        { key: "totalOther", label: "TỔNG KHÁC", shortLabel: "KHÁC" }
      ],
      timeout: null
    };
  },
  computed: {
    localValue: {
      get() { return this.value },
      set(val) { this.$emit("input", val) }
    },
    totalAllMoney() {
      return (
        this.getTotalMoney(this.localValue.totalInventoryMaterials) +
        this.getTotalMoney(this.localValue.totalCeremonyMaterials) +
        this.getTotalMoney(this.localValue.totalNonInventoryMaterials) +
        this.getTotalMoney(this.localValue.totalOther)
      );
    }
  },
  async mounted() {
  },
  methods: {
    onlyNumber,
    formatNumber,

    onlyNumberAndDot(e) {
    const char = String.fromCharCode(e.charCode);
    const allowed = "0123456789."; // chỉ cho phép số và dấu chấm
    if (!allowed.includes(char)) {
      e.preventDefault(); // chặn ký tự
    }
  },
    updateQuantityItem(e, item) {
      const key = e.target.dataset.key;
      let value = e.target.value;
      value = value.replace(/[^0-9.]/g, '');
      const firstDotIndex = value.indexOf('.');
      if (firstDotIndex !== -1) {
        value = value
          .split('')
          .map((c, i) => (c === '.' && i !== firstDotIndex ? '' : c))
          .join('');
      }
      item[key] = parseFloat(value) || 0;
      item.money = (item.quantity || 0) * (item.price || 0);
      e.target.value = value;
    },
    // ✅ Search sản phẩm ở FE (lọc từ danh sách có sẵn)
    searchProduct(item) {
      const keyword = item.detail.toLowerCase().trim();

      if (!keyword) {
        item.results = [];
        item.showSuggestions = false;
        return;
      }

      const filtered = this.productsItem.filter(
        p =>
          p.name.toLowerCase().includes(keyword) ||
          p.code.toLowerCase().includes(keyword)
      );

      item.results = filtered.slice(0, 10); // Giới hạn hiển thị 10 sản phẩm
      item.showSuggestions = true;
    },

    selectProduct(item, product) {
      item.detail = `${product.code} - ${product.name}`;
      item.unit = product.unit || "";
      item.showSuggestions = false;
      item.results = [];
    },

    // --- Các hàm phụ ---
    formatCurrency(value) {
      if (!value) return "0";
      return new Intl.NumberFormat("vi-VN").format(value);
    },
    getTotalMoney(arr) {
      return arr.reduce((sum, item) => sum + (item.money || 0), 0);
    },
    updateMoneyItem(e, item) {
      let key = e.target.dataset.key;
      let value = unformatNumber(e.target.value)
      item[key] = value
      item.money = (item.quantity || 0) * (item.price || 0);
    },
    addRow(section) {
      this.localValue[section].push({
        date: new Date().toISOString().slice(0, 10),
        detail: "",
        unit: "",
        quantity: 0,
        price: 0,
        money: 0,
        note: "",
        showSuggestions: false,
        results: []
      });
    },
    removeRow(section, index) {
      this.localValue[section].splice(index, 1);
    }
  },
  watch: {
    totalAllMoney: {
      handler(newVal) {
        // Gửi tổng tiền lên file cha
        this.$emit('update-total', newVal);
      },
      immediate: true, // Gửi luôn giá trị ban đầu khi mount
    }
  },
};
</script>
